import { Routes } from '@angular/router';
/*import { LoginRootComponent } from '../_pages/login-root/login-root.component';
import { LoginComponent } from '../_pages/login/login.component'; */

export const LoginRouting: Routes = [
   /*  {
        path: 'login', component: LoginRootComponent, canActivateChild: [],
        children: [
            { path: '', component: LoginComponent, pathMatch: 'full' }
        ]
    } */
];

